import { createSlice } from "@reduxjs/toolkit";

const initialPermissionsState = {
    permissions: {
        case_attorney: {
            editDisabled: true
        },
        case_liability: {
            editDisabled: true
        },
        case_major_med: {
            editDisabled: true
        },        
        case_practice: {
            editDisabled: true
        },
        case_aica_department_status: {
            editDisabled: true
        },
        case_mp_pip_um: {
            editDisabled: true
        },
        case_worker_comp: {
            editDisabled: true
        },
        case_additional: {
            editDisabled: true
        }
    },
    editPermissions: {

    }
}


const permissionsSlice = createSlice({
    name: 'permissions',
    initialState: initialPermissionsState,
    reducers: {
        setPermissions(state, data) {
            state.permissions = data.payload
        },
        setEditPermissions(state, data) {
            state.editPermissions = data.payload
        },
    }
})

export const permissionsActions = permissionsSlice.actions

export default permissionsSlice.reducer